import { useState, useEffect, useRef } from 'react';
import _find from 'lodash.find';
import { DateTime } from 'luxon';
import { OverlayPanel } from 'primereact/overlaypanel';
import { getFormattedNumberStr } from '../../utils/number';
import {
  getReasonStrById,
  EditableValue,
  ValueWrapper,
  ValueUpdateInfo,
  SummaryWrapper,
  SummaryLabel,
  StaticValue,
} from './common';
import { useReportDetailStore } from '.';

function MillSourcesSummary({
  data,
  updatedCells,
  reasonsData,
  onUpdate,
}: {
  data: any;
  updatedCells: any[];
  reasonsData: any[];
  onUpdate: any;
}) {
  const [item, setItem] = useState<any>(null);
  const [isUpdated, setUpdated] = useState<boolean>(false);
  const { userPermissions } = useReportDetailStore();
  const op = useRef<OverlayPanel>(null);

  const getDefaultItemData = () => ({
    metricId: data.metricId,
    value: data.value,
    reasonId: data.reasonId,
    metricUnit: data.metricUnit,
    updatedBy: data.createdBy
      ? {
          user: data.createdBy,
          reasonId: data.reasonId,
          updatedAt: data.createdAt,
        }
      : null,
  });

  useEffect(() => {
    if (data) {
      setItem(getDefaultItemData());
    }
  }, [data]);

  useEffect(() => {
    const updatedValue = _find(updatedCells, (i: any) => i.metricId === item?.metricId);

    if (updatedValue) {
      setUpdated(true);
      setItem((prev: any) => ({
        ...prev,
        ...updatedValue,
      }));
    } else {
      setItem(getDefaultItemData());
      setUpdated(false);
    }
  }, [updatedCells]);

  if (!item) {
    return null;
  }

  return (
    <SummaryWrapper>
      <div>
        <SummaryLabel>Mill total:</SummaryLabel>
        <ValueWrapper>
          {userPermissions.canUpdateSources ? (
            <EditableValue
              onClick={() =>
                onUpdate({
                  data: {
                    value: item.value,
                    reasonId: item.reasonId,
                    metricUnit: item.metricUnit,
                    metricId: item.metricId,
                  },
                  isUpdated,
                })
              }
              isUpdated={isUpdated}
            >
              <i className="pi pi-pencil" />
              {getFormattedNumberStr(Math.round(item.value), item.metricUnit)}
            </EditableValue>
          ) : (
            <StaticValue>{getFormattedNumberStr(Math.round(item.value), item.metricUnit)}</StaticValue>
          )}

          {item.updatedBy && (
            <>
              <i className="cellChangeInfo pi pi-info-circle" onClick={(e) => op.current?.toggle(e)} />
              <OverlayPanel
                className="em-custom-overlaypanel"
                ref={op}
                style={{ fontSize: '12px', marginRight: '16px' }}
                showCloseIcon
              >
                <ValueUpdateInfo>
                  <p>Last value update:</p>
                  <span>User:</span>
                  <span>{item.updatedBy.user}</span>
                  <span>Reason:</span>
                  <span>{getReasonStrById(item.updatedBy.reasonId, reasonsData)}</span>
                  <span>Updated at:</span>
                  <span>
                    {item.updatedBy.updatedAt
                      ? DateTime.fromISO(item.updatedBy.updatedAt).toLocaleString({
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric',
                          second: 'numeric',
                        })
                      : '-'}
                  </span>
                </ValueUpdateInfo>
              </OverlayPanel>
            </>
          )}
        </ValueWrapper>
      </div>
    </SummaryWrapper>
  );
}

export default MillSourcesSummary;
